import { useEffect } from "react";
import { CheckCircle2, X, XCircle } from "lucide-react";
import { cn } from "@/lib/utils";

export type ToastKind = "success" | "error" | "info";

export function Toast({
  kind = "info",
  message,
  onClose,
  autoHideMs = 3500,
}: {
  kind?: ToastKind;
  message: string;
  onClose: () => void;
  autoHideMs?: number;
}) {
  useEffect(() => {
    if (!autoHideMs) return;
    const t = setTimeout(onClose, autoHideMs);
    return () => clearTimeout(t);
  }, [autoHideMs, onClose]);

  const styles =
    kind === "success"
      ? "bg-moving-500 text-white"
      : kind === "error"
        ? "bg-red-600 text-white"
        : "bg-slate-900 text-white";
  const Icon = kind === "error" ? XCircle : CheckCircle2;

  return (
    <div
      className={cn(
        "fixed bottom-4 right-4 z-50 flex items-start gap-3 rounded-lg px-4 py-3 shadow-lg",
        "max-w-md animate-in slide-in-from-bottom-4",
        styles,
      )}
      role="status"
      aria-live="polite"
    >
      <Icon className="h-5 w-5 shrink-0" />
      <div className="flex-1 text-sm">{message}</div>
      <button
        onClick={onClose}
        className="text-white/80 hover:text-white"
        aria-label="Chiudi"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
